import React from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import SectionItemNumber from "../SectionItemNumber";

const RegionDeliveryPrice = ({
  item,
  t,
  handleOnChange,
  handleOnDeleteItem,
  inlineType
}) => (
  <div key={`regionDeliveryPrice-${item.id}`} className={classNames("regionDeliveryPrice")}>
    <SectionItemNumber item={item}
      value={item.deliveryPrice}
      column={{
        accessor: "deliveryPrice",
        title: item && item.sourceRegionName ? 
          `${t("settings.map.DEPOT_FIX_DELIVERY_PRICE_TWO_REGIONS_LABEL", {name: item.name, sourceName: item.sourceRegionName})} ${item.applyToBothDirections && item.sourceRegionName ? '(' + t('settings.map.DEPOT_FIX_DELIVERY_PRICE_BOTH_DIRECIONS_LABEL') + ')' : ''}` : `${t("settings.map.DEPOT_FIX_DELIVERY_PRICE_LABEL")} ${(item && item.name) || ""} ${item.applyToBothDirections && item.sourceRegionName ? '(' + t('settings.map.DEPOT_FIX_DELIVERY_PRICE_BOTH_DIRECIONS_LABEL') + ')' : ''}`,
        inlineType: inlineType || ''
      }}
      onPropChange={itemValue=> handleOnChange({ ...item, ...itemValue })}
    />
    <div className={classNames("delete")} onClick={() => handleOnDeleteItem(item.id)} />
  </div>
);

export default withTranslation()(RegionDeliveryPrice);
